
import {
  ApplicationState, initialApplicationState, initialArcGisToken,
  ApplicationStatus,
  SearchCoordinatesPayload, GridSelectLayerPayload, GridPayload,
  ToolboxStatus,
  EditPermissionPayload
} from './application.state';
import { DatePipe } from '@angular/common';


import {
  ApplicationAction, ApplicationActionType, GridSelectLayer,
  GetGridSelectLayerSuccess, InvalidateGridCache, ToolboxMailMerge,
  ToolboxMailMergeSelectedParcels, ToolboxMailMergeToggleParcel
} from './application.action';
import { DnvFeatureLayer, DnvSimpleRenderer, DnvSymbology, DnvUniqueValueRenderer, parseSymbol, parseUVR } from 'dnv-lib';

function formatDate(lst: any): any {
  let tmpAttrs, tmpLst;
  const returnLst = [];
  for (const l of lst) {
    for (let x = 0; x < l.attrs.length; x++) {
      const item = l.attrs;
      if (item[x][0] === 'Date') {
        const formatedDate = new DatePipe('en-CA').transform(item[x][1], 'yyyy-MM-dd');
        // console.log(formatedDate);
        // item[x][1] = formatedDate;
        const temp = {
          ...item[x],
          1: formatedDate
        }
        tmpAttrs = [
          ...l.attrs.slice(0, x),
          temp,
          ...l.attrs.slice(x + 1)
        ]
      }
      // if (item[x][0] === 'Time') {
      //   const formatedTime = new DatePipe('en-CA').transform(item[x][1], 'h:mm a');
      //   // console.log(formatedTime);
      //   item[x][1] = formatedTime;
      // }
    }
    tmpLst = Object.assign({}, l, {
      attrs: tmpAttrs
    })
    returnLst.push(tmpLst);
  }
  return returnLst;
}

// tslint:disable-next-line: typedef
function sortByAsset(assetList: any) {
  const tempList = Object.assign([], assetList);
  const lst = formatDate(tempList);
  let mapped;
  if (lst.length > 0) {
    mapped = lst.map((a: { objectId: string; attrs: any[]; inspType: string; video: string; }) => {
      const item = { objectId: '', attrs: ['', ''], inspType: '', video: '', assetId: '' };
      item.objectId = a.objectId;
      item.attrs = a.attrs;
      item.inspType = a.inspType;
      item.video = a.video;
      item.assetId = a.attrs.filter((t: string[]) => t[0] === 'ASSET_ID')[0][1];

      return item;
    });

    // console.log(mapped);
    return mapped.sort((lhs: { assetId: string; }, rhs: { assetId: any; }) => lhs.assetId.localeCompare(rhs.assetId));
  }
}

function getSymbology(layers: { editableLayers: EditPermissionPayload[], toolName: string }[]): { editableLayers: EditPermissionPayload[], toolName: string }[] {

  return layers.map(layer => {
    const editableLayers: EditPermissionPayload[] = layer.editableLayers.map(edl => {
      return Object.assign({}, edl, { symbology: parseDrawInfo(edl) });
    });

    return Object.assign({}, layer, { editableLayers });
  });

}

function updateSymbology(edl: DnvFeatureLayer, layers: { editableLayers: EditPermissionPayload[], toolname: string }[]): { editableLayers: EditPermissionPayload[], toolname: string }[] {
  const targetLayer = layers.filter(l => l.editableLayers.find(e => e.featureLayerId === edl.featureLayerId)) as any;
  const targetIdx = layers.findIndex(l => (l as any).toolname === (targetLayer as any)[0].toolname);


  const idx = targetLayer.findIndex((t: { editableLayers: any[]; }) => t.editableLayers.find(e => e.featureLayerId === edl.featureLayerId));
  const newEdl = [
    ...targetLayer[0].editableLayers.slice(0, idx),
    Object.assign({}, targetLayer[0].editableLayers[idx], {
      symbology: edl.symbology
    }),
    ...targetLayer[0].editableLayers.slice(idx + 1)
  ]
  //  console.log(newEdl);
  const newLayer = [
    ...layers.slice(0, targetIdx),
    Object.assign({}, layers[targetIdx], {
      editableLayers: newEdl
    }),
    ...layers.slice(targetIdx + 1)
  ];
  //  console.log(newLayer);
  return newLayer;
}

export function parseDrawInfo(editableLayer: EditPermissionPayload): DnvSymbology {
  // if (featureLayer.symbology) {
  //   return featureLayer.symbology;
  // }

  let symbology = null;

  if (editableLayer?.drawingInfo?.renderer) {
    switch (editableLayer.drawingInfo.renderer.type) {
      case "uniqueValue":
        const uniqueValueRenderer = editableLayer.drawingInfo.renderer as DnvUniqueValueRenderer;
        if (!(uniqueValueRenderer.defaultSymbol === null &&
          (
            (uniqueValueRenderer.uniqueValueInfos || []).length === 0 ||
            (uniqueValueRenderer.uniqueValueInfos || []).filter(uvi => !!uvi.symbol).length === 0
          )
        )) {
          symbology = {
            property: '__DEFAULT__' + uniqueValueRenderer.field1,
            defaultSymbol: parseSymbol(uniqueValueRenderer.field1,
              uniqueValueRenderer.defaultLabel,
              uniqueValueRenderer.defaultSymbol),
            symbols: (uniqueValueRenderer.uniqueValueInfos || []).map(uvi => parseUVR(uvi))
          }
        }
        break;
      case "simple":
        const simpleRenderer = editableLayer.drawingInfo.renderer as DnvSimpleRenderer;
        if (simpleRenderer.symbol) {
          symbology = {
            property: '__DEFAULT__',
            defaultSymbol: parseSymbol('',
              editableLayer.featureLayerName,
              simpleRenderer.symbol),
            symbols: []
          }
        }
        break;

      default:
        break;
    }
  }

  return symbology;
}

export function applicationReducer(
  state: ApplicationState = initialApplicationState,
  action: ApplicationAction): ApplicationState {
  switch (action.type) {

    case ApplicationActionType.Error:
      return Object.assign({}, state, {
        status: ApplicationStatus.Error,
      });
    // case ApplicationActionType.Live:
    //   return Object.assign({}, state, {
    //     status: ApplicationStatus.Live,
    //   });
    case ApplicationActionType.Draw:
      return Object.assign({}, state, {
        status: ApplicationStatus.Draw,
      });
    case ApplicationActionType.Table:
      return Object.assign({}, state, {
        status: ApplicationStatus.Table,
      });
    case ApplicationActionType.Legend:
      return Object.assign({}, state, {
        status: ApplicationStatus.Legend,
      });
    case ApplicationActionType.Layer:
      return Object.assign({}, state, {
        status: ApplicationStatus.Layer,
      });
    case ApplicationActionType.Idle:
      return Object.assign({}, state, {
        status: ApplicationStatus.Idle,
      });
    case ApplicationActionType.Toolbox:
      return Object.assign({}, state, {
        status: ApplicationStatus.Toolbox,
      });
    case ApplicationActionType.Measure:
      return Object.assign({}, state, {
        status: ApplicationStatus.Measure,
      });
    case ApplicationActionType.SearchCoordinatesSuccess:
      return Object.assign({}, state, {
        searchCoordinate: (action.payload as SearchCoordinatesPayload)
      });
    case ApplicationActionType.GridSelectLayer:
      return Object.assign({}, state, {
        gridRasterHighlight: {},
        gridSelectLayer: (action as GridSelectLayer).payload.dnvFeatureLayer
      });
    case ApplicationActionType.GetGridSelectLayerSuccess:
      return Object.assign({}, state, {
        gridRasterHighlight: {},
        gridSelectLayerCache: (() => {
          const p: GridSelectLayerPayload = (action as GetGridSelectLayerSuccess).payload;
          const gp: GridPayload = parseGridSelectLayerPayload(p);
          const cache: Map<string, GridPayload> = new Map<string, GridPayload>(state.gridSelectLayerCache);
          cache.set(p.dnvFeatureLayer.uid, gp);
          return cache;
        })()
      });
    case ApplicationActionType.InvalidateGridCache:
      // const cache2: Map<string, GridPayload> = new Map<string, GridPayload>(state.gridSelectLayerCache);
      // cache2.delete('key');
      return Object.assign({}, state, {
        gridRasterHighlight: {},
        gridSelectLayerCache: (() => {
          const p: GridSelectLayerPayload = (action as InvalidateGridCache).payload;
          if (p === null) {
            return new Map<string, GridPayload>();
          }

          // const gp: GridPayload = parseGridSelectLayerPayload(p);
          const cache: Map<string, GridPayload> = new Map<string, GridPayload>(state.gridSelectLayerCache);
          // cache.set(p.dnvFeatureLayer.uid, gp);
          if (cache.has(p.dnvFeatureLayer.uid)) {
            cache.delete(p.dnvFeatureLayer.uid);
          }
          return cache;
        })()
      });
    case ApplicationActionType.SetGridRasterHighlight:
      return Object.assign({}, state, {
        gridRasterHighlight: action.payload
      });
    case ApplicationActionType.SetFeatureRasterHighlight:
      return Object.assign({}, state, {
        featureRasterHighlight: action.payload
      });
    case ApplicationActionType.UpdateWindowSize:
      return Object.assign({}, state, {
        windowInnerHeight: action.payload.windowInnerHeight,
        windowInnerWidth: action.payload.windowInnerWidth
      });
    case ApplicationActionType.SetSelectedFeatureSections:
      return Object.assign({}, state, {
        kvSections: action.payload
      });
    case ApplicationActionType.ConcatSelectedFeatureSections:
      return Object.assign({}, state, {
        kvSections: [...state.kvSections, action.payload]
      });
    case ApplicationActionType.Export:
      return Object.assign({}, state, {
        status: ApplicationStatus.Export,
      });
    // case ApplicationActionType.EngDraw:
    //   return Object.assign({}, state, {
    //     toolboxStatus: ToolboxStatus.EngDrawing,
    //   });
    // case ApplicationActionType.SvcConn:
    //   return Object.assign({}, state, {
    //     toolboxStatus: ToolboxStatus.ServiceConnections,
    //   });
    case ApplicationActionType.RenewArcGisTokenSuccess:
      return Object.assign({}, state, {
        arcGisToken: action.payload.success,
      });
    case ApplicationActionType.RenewArcGisTokenError:
      return Object.assign({}, state, {
        arcGisToken: initialArcGisToken
      });
    // case ApplicationActionType.CCTV:
    //   return Object.assign({}, state, {
    //     toolboxStatus: ToolboxStatus.CCTV
    //   });

    case ApplicationActionType.SearchSuccess:
    case ApplicationActionType.SearchError:
    case ApplicationActionType.Search:
      return Object.assign({}, state, { //state = applicationState
        search: action.payload
      });
    case ApplicationActionType.SetCCTV:
      return Object.assign({}, state, {
        cctvInspections: sortByAsset(action.payload)
      });

    case ApplicationActionType.SelectCCTV:
      return Object.assign({}, state, {
        selectedCctvInspection: action.payload
      });

    case ApplicationActionType.SetCCTVNotes:
      return Object.assign({}, state, {
        cctvNotes: action.payload
      });

    case ApplicationActionType.SearchReset:
      return Object.assign({}, state, {
        search: null
      });
    // case ApplicationActionType.PropInfo:
    //   return Object.assign({}, state, {
    //     toolboxStatus: ToolboxStatus.PropertyInfo
    //   });

    case ApplicationActionType.SetToolboxStatus:
      return Object.assign({}, state, {
        toolboxStatus: action.payload
      });

    case ApplicationActionType.ToolboxMailMerge:
      const tbmm = action as ToolboxMailMerge;
      let tbmmState = tbmm.payload.toolboxMailMergeState;
      if (tbmm.payload.invalidate) {
        tbmmState = Object.assign({}, tbmmState, {
          area: {},
          bufferedArea: {},
          selectedParcels: [],
          resultCount: 0
        });
      }

      return Object.assign({}, state, {
        toolboxMailMergeState: tbmmState
      });

    case ApplicationActionType.ToolboxMailMergeArea:
      // const tbmm = action as ToolboxMailMerge;
      // let tbmmState = tbmm.payload.toolboxMailMergeState;
      // if (tbmm.payload.invalidate) {
      //   tbmmState = Object.assign({}, tbmmState, {
      //     area: {},
      //     bufferedArea: {},
      //     selectedParcels: []
      //   });
      // }
      const tbmma = Object.assign({}, state.toolboxMailMergeState, {
        area: action.payload,
        bufferedArea: {},
        selectedParcels: []
      });

      return Object.assign({}, state, {
        toolboxMailMergeState: tbmma
      });

    case ApplicationActionType.ToolboxMailMergeBuffer:
      const tbmmb = Object.assign({}, state.toolboxMailMergeState, {
        bufferedArea: action.payload,
        selectedParcels: []
      });

      return Object.assign({}, state, {
        toolboxMailMergeState: tbmmb
      });

    case ApplicationActionType.ToolboxMailMergeSelectedParcels:
      const tbmmsp = Object.assign({}, state.toolboxMailMergeState, {
        selectedParcels: action.payload
      });

      return Object.assign({}, state, {
        toolboxMailMergeState: tbmmsp
      });

    case ApplicationActionType.ToolboxMailMergeToggleParcel:
      let parcels = [...state.toolboxMailMergeState.selectedParcels];
      const parcelIndex = parcels.findIndex(p => p.url === action.payload.url);

      if (parcelIndex < 0) { // Add the parcel
        parcels.push(action.payload);
      } else { // Remove the parcel
        parcels = [
          ...parcels.slice(0, parcelIndex),
          ...parcels.slice(parcelIndex + 1)
        ];
      }
      const tbmmtp = Object.assign({}, state.toolboxMailMergeState, {
        selectedParcels: parcels // add or remove as needed
      });

      return Object.assign({}, state, {
        toolboxMailMergeState: tbmmtp
      });

    case ApplicationActionType.ToolboxMailMergeUpdateOptions:
      const tbmmuo = Object.assign({}, state.toolboxMailMergeState, {
        isOwners: action.payload.isOwners,
        isOccupants: action.payload.isOccupants,
        groupOwners: action.payload.groupOwners,
        prefOwn: action.payload.prefOwn,
      });

      return Object.assign({}, state, {
        toolboxMailMergeState: tbmmuo
      });

    case ApplicationActionType.ToolboxMailMergeUpdateResultCountSuccess:
      const tbmmurcs = Object.assign({}, state.toolboxMailMergeState, {
        resultCount: action.payload
      });

      return Object.assign({}, state, {
        toolboxMailMergeState: tbmmurcs
      });

    case ApplicationActionType.SetMailMergeList:
      return Object.assign({}, state, {
        mailMergeList: action.payload
      });

    case ApplicationActionType.SetMailMergeDBLinks:
      return Object.assign({}, state, {
        mailMergeDBLinks: action.payload
      });

    case ApplicationActionType.ToggleStreetView:
      return Object.assign({}, state, {
        streetView: !state.streetView
      });

    case ApplicationActionType.SetMeasurements:
      return Object.assign({}, state, {
        measurements: action.payload
      });

    case ApplicationActionType.SetEditFeature:
      return Object.assign({}, state, {
        editFeature: action.payload
      });

    case ApplicationActionType.SetEditPermission:
      return Object.assign({}, state, {
        editPermission: getSymbology(action.payload)
      });

    case ApplicationActionType.SetEditPermissionSymbology:
      return Object.assign({}, state, {
        editPermission: updateSymbology(action.payload, state.editPermission)
      });

    case ApplicationActionType.SetNewFeatureLatLng:
      return Object.assign({}, state, {
        newFeatureLatLng: action.payload
      });

    case ApplicationActionType.SetLastEditFeature:
      return Object.assign({}, state, {
        lastEditFeature: action.payload
      });

    case ApplicationActionType.SetMaxAssetId:
      return Object.assign({}, state, {
        maxAsset: action.payload
      });

    case ApplicationActionType.GetMaxAssetIdError:
      return Object.assign({}, state, {
        maxAsset: action.payload
      });

    case ApplicationActionType.SetShowSpinner:
      return Object.assign({}, state, {
        spinner: action.payload
      });

    case ApplicationActionType.SetShowSearchSpinner:
      return Object.assign({}, state, {
        searchSpinner: action.payload
      });

    case ApplicationActionType.SetUserProfile:
      return Object.assign({}, state, {
        userProfile: action.payload
      });

    case ApplicationActionType.SetEditFeatureFields:
      return Object.assign({}, state, {
        editFeatureFields: action.payload
      });

    case ApplicationActionType.SetAppSettings:
      return Object.assign({}, state, {
        appSettings: action.payload
      });

    case ApplicationActionType.SetRelatedRecords:
      return Object.assign({}, state, {
        relatedRecords: extractAttrs(action.payload, null, null)
      });

    // case ApplicationActionType.SetInspectionAttachments:
    //   return Object.assign({}, state, {
    //     selectedFeatureInspections: setInspAttachments(state, action.payload)
    //   });

    case ApplicationActionType.SetRelatedAttachments:
      return Object.assign({}, state, {
        relatedRecords: setRelatedAttachments(state, action.payload)
      });

    case ApplicationActionType.SetFeatureAttachments:
      return Object.assign({}, state, {
        selectedFeatureAttachments: action.payload
      });
    case ApplicationActionType.ShowThumbnails:
      return Object.assign({}, state, {
        galleryOptions: toggleThumbnails(state)
      });
    case ApplicationActionType.ConcatRelatedRecords:
      const extracted = extractAttrs(action.payload.records, action.payload.subtypeField, action.payload.subtypes);
      const inArray = state.relatedRecords.filter((r: { tblName: any; }) => r.tblName === action.payload.name);
      if (extracted && extracted.length > 0 && inArray.length === 0) {
        const recs = {
          tblName: action.payload.name,
          records: extracted,
          subtypeField: action.payload.subtypeField,
          subtypes: action.payload.subtypes
        };

        return Object.assign({}, state, {
          relatedRecords: [
            ...state.relatedRecords,
            recs
          ]
        });
      }
      return Object.assign({}, state, {
        relatedRecords: state.relatedRecords

      });
      break;

    case ApplicationActionType.SetEditRequiredFields:
      return Object.assign({}, state, {
        editRequiredFields: action.payload
      });

    case ApplicationActionType.SetEditReadOnlyFields:
      return Object.assign({}, state, {
        editReadOnlyFields: action.payload
      });

    case ApplicationActionType.SetExternalFeature:
      return Object.assign({}, state, {
        externalFeature: action.payload
      });

    case ApplicationActionType.ToggleAlert:
      return Object.assign({}, state, {
        alertHidden: action.payload ? action.payload : !state.alertHidden
      });

    case ApplicationActionType.SetEditFeatureShowActiveLayer:
      return Object.assign({}, state, {
        editFeatureShowActiveLayer: action.payload
      });

    case ApplicationActionType.SearchAsset:
      return Object.assign({}, state, {
        searchAsset: action.payload
      });

    case ApplicationActionType.SetCAD:
      return Object.assign({}, state, {
        cad: action.payload
      });

    case ApplicationActionType.SetOutstandingED:
      return Object.assign({}, state, {
        outstandingED: action.payload
      });

    case ApplicationActionType.ShapeCreated:
      return Object.assign({}, state, {
        shapeCreated: action.payload
      });

    case ApplicationActionType.SetToolsPermissions:
      return Object.assign({}, state, {
        toolsPermissions: action.payload
      });

    case ApplicationActionType.PopulationSelectMode:
      return Object.assign({}, state, {
        populationState: Object.assign({}, state.populationState, {
          selectionMethod: action.payload
        })
      });

    case ApplicationActionType.PopulationSelectedArea:

      return Object.assign({}, state, {
        populationState: Object.assign({}, state.populationState, {
          selectedArea: action.payload
        })
      });

    case ApplicationActionType.PopulationSetState:

      return Object.assign({}, state, {
        populationState: Object.assign({}, state.populationState, {
          buildings: action.payload
        })
      });

    case ApplicationActionType.PopulationClearSelectedArea:

      return Object.assign({}, state, {
        populationState: Object.assign({}, state.populationState, {
          selectedArea: action.payload
        })
      });

    case ApplicationActionType.SetFromMeasureTool:

      return Object.assign({}, state, {
        fromMeasureTool: action.payload
      });

    default:
      return state;
  }
}

// https://gist.github.com/renaudtertrais/25fc5a2e64fe5d0e86894094c6989e10
// zip([a1, a2, a3], [b1, b2, b3]) => [[a1, b1], [a2, b2], [a3, b3]]
const zip = (arr: any[], ...arrs: any[]) => {
  return arr.map((val, i) => arrs.reduce((a, arrr) => [...a, arrr[i]], [val]));
};

export function cleanLabel(s: string): string {
  return s.replace(/\./g, '_');
}

export function parseGridSelectLayerPayload(payload: GridSelectLayerPayload): GridPayload {
  const data: object[] = [];
  const geometry: object[] = [];
  let fieldAliases: object[] = [];
  let objectid: string = 'OBJECTID';
  let objectidclean: string = 'OBJECTID';
  const propertyDomainMap: Map<string, { [id: string]: string }> = new Map<string, { [id: string]: string }>();

  payload.dnvFeatureLayer.meta.forEach(m => {
    if (m.domain?.length > 0) {
      const domainMap: { [id: string]: string } = {};
      m.domain.forEach(d => {
        domainMap[d.code] = d.name;
      });
      propertyDomainMap.set(m.name, domainMap);
    }
  });


  if (payload.success.fieldAliases) {
    let keys = Object.getOwnPropertyNames(payload.success.fieldAliases);
    let alias = keys.map(k => payload.success.fieldAliases[k]);


    const typeMap = new Map<string, string>(
      payload.success.fields.map((x: { name: string; type: string; }) => [x.name, x.type] as [string, string])
    );
    const dateTypeColumnsMap = new Map<string, string>(
      payload.success.fields
        .filter((x: { name: string; type: string; }) => 'esriFieldTypeDate' === x.type)
        .map((x: { name: string; type: string; }) => [x.name, x.type] as [string, string])
    );

    const esriFieldTypeOIDs = payload.success.fields
      .filter((x: { name: string; type: string; }) => 'esriFieldTypeOID' === x.type)
    if (esriFieldTypeOIDs.length > 0) {
      objectid = esriFieldTypeOIDs[0].name;
      objectidclean = cleanLabel(esriFieldTypeOIDs[0].name);
    }

    const types = keys.map(value => {
      return typeMap.get(value);
    });

    keys = keys.map(s => cleanLabel(s));
    alias = alias.map(s => cleanLabel(s));

    // let dateTimeColumns: string[] = [];

    // typeMap.forEach((value: string, key: string) => {
    //   if (value === 'esriFieldTypeDate')
    //     dateTimeColumns.push(key);
    // });

    fieldAliases = zip(keys, alias, types);


    if (payload.success.features) {
      payload.success.features.forEach((f: any) => {
        const attributeKeys = Object.getOwnPropertyNames(f.attributes);
        const attribute: { [id: string]: any } = {};
        attributeKeys.forEach(k => {
          if (propertyDomainMap.has(k)) {
            attribute[cleanLabel(k)] = propertyDomainMap.get(k)[f.attributes[k]];
          } else {
            if (dateTypeColumnsMap.has(k) && f.attributes[k]) {
              attribute[cleanLabel(k)] = new Date(f.attributes[k]);
            } else {
              attribute[cleanLabel(k)] = f.attributes[k];
            }
          }
        });

        data.push(attribute);
        geometry.push(f.geometry);
      });
    }

    // newData = data.map((row: any) => {
    //   const newDateColumns = dateTimeColumns.reduce((accumulator: object, colName: string) => {
    //     if (row[colName]) {
    //       accumulator = Object.assign({}, row, { [colName]: new Date(row[colName] ) });
    //     }
    //     // else {
    //     //   accumulator = Object.assign({}, row, { [colName]: new Date(8*60*60*1000) });
    //   // Thu Jan 01 1970 00:00:00 GMT-0800 (Pacific Standard Time)
    //     // }
    //     return accumulator;
    //   }, {})
    //   return Object.assign({}, row, newDateColumns)
    // });


  }

  return { fieldAliases, geometry, data, objectid, objectidclean };
}

export function extractAttrs(records: any, subtypeField: string, subtypes: any) {
  const insp: any = [];
  let objId = 0;
  let ob: any = [];
  let isEnergov = false;
  if (records && records.data) {
    if (records.data.relatedRecordGroups.length > 0) {
      for (let i = 0; i < records.data.relatedRecordGroups.length; i++) {
        let recordAttrs = records.data.relatedRecordGroups[i].relatedRecords;
        if (records.data.url.toLowerCase().indexOf('energov') > -1) {
          // different sorting for energov layers
          // sort by first 3 characters of number then date desc
          // console.log(recordAttrs.sort(case_sort));
          recordAttrs = [...recordAttrs].sort(case_sort);
          isEnergov = true;
        } else {
          // sort by created date desc
          if (recordAttrs.length > 1) {
            recordAttrs = [...recordAttrs].sort(date_sort);
          }
        }

        for (let x = 0; x < recordAttrs.length; x++) {
          let fprops = recordAttrs[x].attributes;
          const arr: Array<[string, string]> = [];
          for (const prop in fprops) {
            if (fprops.hasOwnProperty(prop)) {
              const kvPair = records.meta.filter((a: { name: string; }) => a.name === prop);
              let alias = prop;
              if (kvPair.length > 0) {
                alias = kvPair[0].alias;
              }
              if (prop === subtypeField) {
                const typeName = subtypes.filter((s: any) => s.code === fprops[prop]);
                if (typeName != null && typeName.length > 0) {
                  fprops = { ...fprops, [prop]: typeName[0].name };
                }
              }
              if (prop.toLowerCase().indexOf('date') > -1) {
                if (fprops[prop] && fprops[prop].toString().length > 4) {
                  const convertedDate = new Date(fprops[prop]);
                  let dateString = convertedDate.toString().substring(4, convertedDate.toString().indexOf('GMT')).trim();
                  if (isEnergov) {
                    dateString = new DatePipe('en-CA').transform(convertedDate, 'MMM dd yyyy');;
                  }
                  arr.push([alias, dateString]);
                } else {
                  // date value but only year
                  arr.push([alias, fprops[prop]]);
                }
              } else {
                // not date value
                if (prop.toLowerCase() === 'objectid') {
                  objId = fprops[prop];
                }
                arr.push([alias, fprops[prop]]);
              }
            }

          }
          ob = { objectId: objId, attrs: arr };
          insp.push(ob);

        }
      }
    }
  }
  return insp;
}

export function date_sort(a: any, b: any) {
  return new Date(b.attributes.created_date).getTime() - new Date(a.attributes.created_date).getTime();
}

export function case_sort(a: any, b: any): any {
  if (a.attributes.CodeCaseNumber) {
    return a.attributes.CodeCaseNumber.substr(0, 3).localeCompare(b.attributes.CodeCaseNumber.substr(0, 3)) || b.attributes.OpenedDate - a.attributes.OpenedDate;
  }
  if (a.attributes.PermitNumber) {
    return a.attributes.PermitNumber.substr(0, 3).localeCompare(b.attributes.PermitNumber.substr(0, 3)) || b.attributes.IssueDate - a.attributes.IssueDate;

  }
  if (a.attributes.PlanNumber) {
    return a.attributes.PlanNumber.substr(0, 3).localeCompare(b.attributes.PlanNumber.substr(0, 3)) || b.attributes.ApplyDate - a.attributes.ApplyDate;

  }
  if (a.attributes.LicenseNumber) {
    return a.attributes.LicenseNumber.substr(0, 3).localeCompare(b.attributes.LicenseNumber.substr(0, 3)) || b.attributes.LicenseYear - a.attributes.LicenseYear;

  }
}

export function setRelatedAttachments(state: ApplicationState, attachInfo: { parentID: number; attachment: any; }[]) {
  if (attachInfo) {
    let attachLookup: any = {};
    attachInfo.forEach(info => { attachLookup[info.parentID] = info.attachment; });
    let newRelatedRecords: any[] = [];
    state.relatedRecords.forEach((recordGroup: any, index: number) => {
      let newRecordGroup: any = Object.assign({}, recordGroup);
      newRecordGroup.records = [];
      recordGroup.records.forEach((record: any) => {
        let newRecord: any = Object.assign({}, record);
        if (attachLookup[record.objectId] !== undefined) {
          newRecord.attachment = attachLookup[record.objectId];
          // set gallery options for individual record
          newRecord.galleryOptions = Object.assign([], state.galleryOptions);
          let rowCount = Math.ceil(newRecord.attachment.length / 4);
          if (newRecord.attachment.length > 4 && newRecord.attachment.length % 4 > 0) {
            rowCount = rowCount + 1;
          }

          newRecord.galleryOptions[0] = {
            ...newRecord.galleryOptions[0],
            thumbnailRows: rowCount === 0 ? 1 : rowCount
          };
          if (newRecord.attachment.length === 2) {
            for (let i = 0; i < newRecord.galleryOptions.length; i++) {
              if (newRecord.galleryOptions[i].arrowPrevIcon === undefined) {
                newRecord.galleryOptions[i] = {
                  ...newRecord.galleryOptions[i],
                  thumbnails: true,
                  imageArrows: true,
                  thumbnailsRows: rowCount
                }
              }
            }
          }
        }
        newRecordGroup.records.push(newRecord);
      })
      newRelatedRecords.push(newRecordGroup);
    });
    return newRelatedRecords;
  }
  return state.relatedRecords;
}

export function toggleThumbnails(state: ApplicationState) {
  let showThumbs = false;
  if (Number(state.selectedFeatureAttachments.images.length) === 1) {
    showThumbs = false;
  } else {
    showThumbs = true;
  }

  // let rowCount = Math.round(Number(state.selectedFeatureAttachments.images.length) / 4);
  // if (Number(state.selectedFeatureAttachments.images.length) % 4 > 0) {
  //   rowCount = rowCount + 1;
  // }

  return [Object.assign({}, state.galleryOptions[0]
    , { thumbnails: showThumbs, 'imageArrows': showThumbs })
    , ...state.galleryOptions.slice(1)];
}
